import { t } from '@lingui/core/macro';
import { Dashboard } from 'components/Dashboard/Dashboard';
import { DashboardProvider } from 'components/Dashboard/Dashboard.context';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { ExistingIntroducerModal } from 'components/PortalTours/ExistingIntroducerModal/ExistingIntroducerModal';
import { FirstAppModal } from 'components/PortalTours/FirstAppModal/FirstAppModal';
import { useHomePageTutorials } from 'hooks/useHomePageTutorials';
import { useTrackingIdentify } from 'utils/tracking/tracking.hooks';
import styles from './home.module.css';

export const HomePage = () => {
  useTrackingIdentify();

  const {
    hasAccessToPortalTours,
    showExistingOptInModal,
    showFirstAppModal,
    setIsExistingModalDismissed,
    setIsFirstAppModalDismissed,
    triggerDashboardTour,
  } = useHomePageTutorials();

  return (
    <BaseLayout
      pageTitle={t`Dashboard | Introducer Portal`}
      className={styles.dashboardLayout}
      showDEFooter
    >
      <DashboardProvider>
        <Dashboard />
      </DashboardProvider>

      {showExistingOptInModal && hasAccessToPortalTours && (
        <ExistingIntroducerModal
          triggerDashboardTour={triggerDashboardTour}
          showModal={showExistingOptInModal}
          closeModal={() => setIsExistingModalDismissed(true)}
        />
      )}

      {showFirstAppModal && hasAccessToPortalTours && (
        <FirstAppModal
          triggerTour={triggerDashboardTour}
          showModal={showFirstAppModal}
          closeModal={() => setIsFirstAppModalDismissed(true)}
        />
      )}
    </BaseLayout>
  );
};
